import { useState } from 'react'

import { $getSelectionStyleValueForProperty } from '@lexical/selection'
import { useMemoizedFn } from 'ahooks'
import { $getSelection, $isRangeSelection } from 'lexical'
import { isNil } from 'lodash'

import { $setSelectionStyle } from '../../utils/style'
import { useEditor } from '../useEditor'
import { useSelectionChange } from '../useSelectionChange'

import { UseSelectionStyleProps } from './interface'

/**
 * 选中区域的样式
 */
export const useSelectionStyle = ({
  name,
  defaultValue
}: UseSelectionStyleProps) => {
  const defaultValueString = `${defaultValue}`

  const editor = useEditor()
  const [style, _setStyle] = useState<string | undefined>(defaultValueString)

  const getSelectionFontSizeHandler = () => {
    const selection = $getSelection()
    if ($isRangeSelection(selection)) {
      const value = $getSelectionStyleValueForProperty(
        selection,
        name,
        isNil(defaultValue) ? undefined : defaultValueString
      )
      _setStyle(value)
    }
    return false
  }
  useSelectionChange(getSelectionFontSizeHandler)

  const setStyle = useMemoizedFn((value: string | number) => {
    const valueString = `${value}`
    _setStyle(valueString)
    $setSelectionStyle(editor, {
      [name]: valueString
    })
  })

  return [style, setStyle] as const
}
